module.exports = __webpack_public_path__ + "static/media/expand-content-white.5305b925.svg";